<template>
  <div class="goods-box">
    <div v-if="!showNullPage">
      <div class="table">
        <div class="table-operator">
          <div class="school-left">
            <span>学校</span>
            <div class="sch-form-item">
              <span v-if="portOrg == 2">{{ userInfo.orgName }}</span>
              <Select
                v-if="portOrg != 2"
                v-model="selectSchoolId"
                placeholder="请选择学校"
                clearable
              >
                <Option
                  v-for="(item, index) in isShelvesSchoolList"
                  :key="index"
                  :value="item.orgId"
                  >{{ item.orgName }}</Option
                >
              </Select>
            </div>
          </div>
          <div class="icon-right">
            <Icon
              type="md-settings"
              size="22"
              color="#488ffa"
              style="margin-left: 16px; cursor: pointer"
              @click="handleColumn"
            ></Icon>
          </div>
        </div>
        <Table
          ref="dataTable"
          border
          :columns="columnsShow"
          :data="goodsList"
          @on-row-click="selectRow"
          @on-selection-change="tableColumnsChange"
          :loading="tableLoading"
        >
          <template slot="schoolName" slot-scope="{ row }">
            <div v-if="row.schoolName && row.schoolName.length > 26">
              <Poptip trigger="hover" word-wrap width="200">
                <span>{{
                  row.schoolName.length > 26
                    ? row.schoolName.slice(0, 26) + '...'
                    : row.schoolName
                }}</span>
                <div slot="content">
                  <span>{{ row.schoolName }}</span>
                </div>
              </Poptip>
            </div>
            <div v-else>{{ row.schoolName }}</div>
          </template>
          <template slot="classType" slot-scope="{ row }">
            <span v-if="row.classType == 1">素质课</span>
            <span v-if="row.classType == 2">基础托管</span>
          </template>
          <template slot="studentTotal" slot-scope="{ row }">
            <span v-if="row.studentTotal === 0">不限</span>
            <span v-if="row.studentTotal != 0">{{ row.studentTotal }}</span>
          </template>
          <template slot="courseTypeKind" slot-scope="{ row }">
            {{ getcourseType(row.courseTypeKind) }}
          </template>
          <template slot="classroomFee" slot-scope="{ row }">
            <span>{{ feetoFixed(row.classroomFee) }}</span>
          </template>
          <template slot="courseEnrollState" slot-scope="{ row }">
            <span>{{ courseEnrollStateFill[row.courseEnrollState] }}</span>
          </template>
          <template slot="isPreEnroll" slot-scope="{ row }">
            <span>{{ isPreEnrollFill[row.isPreEnroll] }}</span>
          </template>
          <template slot="visibleType" slot-scope="{ row }">
            <span v-if="row.visibleType == 0"
              ><span style="color: #eeb449">不可见</span></span
            >
            <span v-if="row.visibleType == 1"><span>可见</span></span>
            <span v-if="row.visibleType == 2"><span>指定范围可见</span></span>
          </template>
          <template slot="classroomState" slot-scope="{ row }">
            <div v-if="row.classroomState == 4" class="state-green-430">
              <span></span
              ><!-- 文字前的点 -->
              <span>已上架</span>
            </div>
            <div v-if="row.classroomState == 0" class="state-red-430">
              <span></span>
              <span>已下架</span>
            </div>
            <!--  <Tag v-if="row.classroomState == 4" type="dot" color="success"
            ><span style="color: green">已上架</span></Tag
          >
          <Tag v-if="row.classroomState == 0" type="dot" color="error"
            ><span style="color: red">已下架</span></Tag
          > -->
          </template>
          <template slot="action" slot-scope="{ row, index }">
            <Button
              v-if="
                portOrg == 0 ||
                portOrg == 2 ||
                (portOrg == 3 &&
                  row.exsitOrder === 'false' &&
                  row.classroomState == 0)
              "
              type="text"
              size="small"
              style="margin-right: 5px; color: #488ffa"
              @click.stop="handleUpdate(row)"
              >编辑</Button
            >
            <Button
              v-if="portOrg == 3"
              type="text"
              size="small"
              style="margin-right: 5px; color: #488ffa"
              @click.stop="handleToDetail(row)"
              >详情</Button
            >
            <Button
              type="text"
              size="small"
              style="margin-right: 5px; color: #488ffa"
              @click.stop="handleToOrder(row)"
              >订单</Button
            >
            <!-- 已上架且报名人数不为0的就可以删除  机构和教育局不可以删除-->
            <Button
              v-if="
                !(row.classroomState == 4 && row.registeredNumbers != 0) &&
                portOrg != 3 &&
                portOrg != 1
              "
              type="text"
              size="small"
              style="margin-right: 5px; color: #ff0000"
              @click.stop="handleRemove(row, index)"
              >删除</Button
            >
          </template>
        </Table>
      </div>
      <div class="paging">
        <Page
          :current="page.pageNum"
          :total="page.total"
          :page-size="page.pageSize"
          show-total
          show-elevator
          @on-change="pageChange"
        ></Page>
      </div>
    </div>
    <div v-if="showNullPage" class="list-null">
      <img :src="nullImg" alt="" />
      <div class="null-span">亲亲，您的课程商品为空，可点击下方进行添加哦~</div>
      <Button type="primary" @click="handleRelease">点击发布课程商品</Button>
    </div>
    <BatchSettingModal
      ref="batchSettingModal"
      :classroom-ids="classroomIds"
      @batchSetSuccess="editSuccess"
    ></BatchSettingModal>
    <ChooseColumns
      :show="isShowChooseColumns"
      :column-key="columnKey"
      :columns="columnsForChooseColumns"
      @on-cancel="isShowChooseColumns = false"
      @on-ok="onChooseColumnsOk"
    ></ChooseColumns>
    <ChooseAndModal
      ref="chooseSchool"
      modal-title="请先选择课程商品要发布的学校"
      :modal-width="400"
      :table-column="schoolListColumn"
      :table-data="isShelvesSchoolList"
      :show-page="false"
      @emitSelectData="getSelectSchoolRow"
    >
    </ChooseAndModal>
  </div>
</template>
<script>
import courseCenterApi from "@/request/courseCenter/index.js";
import operationAdminApi from "@/request/operationAdmin/index.js";
import { dealTimeList } from "@/utils/utils.js";
import {
  columns,
  selectArr,
  operatorArr,
} from "@pv/courseCenter/commodity/assets/data/commodityTable.js";
import ChooseColumns from "@c/ChooseColumns";
import BatchSettingModal from "@pv/courseCenter/commodity/assets/components/BatchSettingModal";
import ChooseAndModal from "@c/ChooseAndModal.vue";
import { mapState } from "vuex";
export default {
  components: {
    ChooseColumns,
    BatchSettingModal,
    ChooseAndModal,
  },
  props: {
    isShelvesSchoolList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns: [...columns],
      goodsList: [],
      page: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      courseEnrollStateFill: ["预报名", "报名中", "已报满", "已截止", "已下架"],
      courseTypeList: [
        ["", "艺术", "科技", "体育", "美术", "综合实践"],
        ["", "早托", "午托", "晚托", "全托"],
      ],
      isPreEnrollFill: ["否", "是"],
      portOrg: "", // 0运营端 2学校端 3机构 1教育局
      showBatchModal: false,
      isShowChooseColumns: false,
      columnKey: "",
      selectSchoolId: "", // 选择的学校
      loadingSchool: false,
      schoolIdList: [],
      classroomIds: [],
      nullImg: require("@/assets/img/goods_list_null.png"),
      selectArr: [...selectArr],
      operatorArr: [...operatorArr],
      hasGetApi: false,
      showNullPage: false,
      schoolName: "",
      schoolListColumn: [
        {
          title: "学校名称",
          key: "orgName",
          minWidth: 200,
        },
      ], // 学校列表表格column
      schoolList: [], // 学校数据列表
      schoolPageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1,
      }, // 学校数据的page信息
      selectSchoolData: {}, // 选择到的学校数据
      isShelves: -1,
      columnsForChooseColumns: [],
      tableLoading: false,
      loading: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
    columnsShow() {
      return this.selectArr.concat(this.columns, this.operatorArr);
    },
  },
  watch: {
    selectSchoolId(newVal) {
      this.page.pageNum = 1;
      this.goodsList = [];
      this.hasGetApi = false;
      this.getgoodsTableListFun();
    },
  },
  created() {
    this.portOrg = Number(localStorage.getItem("portOrg"));
    this.isShelves = +this.$route.query.isShelves;
    this.remoteGetSchoolList("");
    this.getgoodsTableListFun();
    this.columns.splice(0, 1);
    this.columns.pop();
    this.columnsForChooseColumns = [...this.columns];
    this.columnKey = `${this.$route.path}${this.portOrg}`;
  },
  methods: {
    loadAllList(val) {
      if (!val) {
        this.remoteGetSchoolList("");
      }
    },
    // 选择某一行
    selectRow(row, index) {
      this.$refs.dataTable.toggleSelect(index);
    },
    // 动态搜索
    remoteGetSchoolList(query) {
      query ? (this.loadingSchool = true) : "";
      // const queryTrue = query && query.length === 1 ? '' : query;
      const queryTrue = query;
      if (this.portOrg === 0 || this.portOrg === 1) {
        // 运营0和教育局1
        this.getgoodSchoolListFun(queryTrue);
      }
      if (this.portOrg === 3) {
        // 机构

        this.getMechanismSchoolListFun(queryTrue);
      }
    },
    // 搜索框 学校列表 运营端,教育局
    async getgoodSchoolListFun(query) {
      console.log("getgoodSchoolListFun", query);
      const params = {};
      !query ? (params.searchStr = "") : (params.searchStr = query);
      // if (this.searchConds.schoolId) {
      //   params.searchStr = '';
      // }
      const res = await courseCenterApi.getgoodSchoolList(params);
      this.loadingSchool = false;
      if (res.status === 200) {
        console.log("请求---------学校");
        const arr = [{ orgId: -1, name: "全部学校" }];
        this.schoolIdList = [
          ...arr,
          ...res.message.list.map((item) => {
            return { orgId: item.orgId, name: item.name };
          }),
        ];
      }

      // this.handleSelectSchHack();
    },
    // 请求学校列表(机构端)
    async getMechanismSchoolListFun(query) {
      const params = {
        pageNum: 1,
        pageSize: 1000,
      };

      !query ? (params.searchStr = "") : (params.searchStr = query);
      // if (this.searchConds.schoolId) {
      //   params.searchStr = '';
      // }
      console.log(query, "queryquery");
      const res = await operationAdminApi.getListSchoolsNewAdmin(params);
      if (res.status === 200) {
        const arr = [{ orgId: -1, name: "全部学校" }];
        this.schoolIdList = [...arr, ...res.message.list];
      }
      this.loadingSchool = false;
      // this.handleSelectSchHack();
    },
    // 处理课程二级类
    getcourseType(courseTypeKind) {
      if (courseTypeKind) {
        const str = courseTypeKind.toString();
        if (str.length === 2) {
          return this.courseTypeList[Number(str.slice(0, 1)) - 1][
            Number(str.slice(1, 2))
          ];
        }
      }
    },
    feetoFixed(money) {
      return (money / 100).toFixed(2);
    },
    // 选中的商品ID
    tableColumnsChange(selection) {
      this.activeselection = selection;
      this.classroomIds = selection.map((item) => {
        return item.classroomId;
      });
      // 多选的时候，加多这个可以点击整行也勾选或者去掉勾选
    },
    // 翻页
    pageChange(current) {
      this.page.pageNum = current;
      this.getgoodsTableListFun();
    },
    // table列表
    async getgoodsTableListFun() {
      const params = {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        courseId: this.$route.query.courseId,
      };
      params.schoolId = this.selectSchoolId === -1 ? "" : this.selectSchoolId;
      this.tableLoading = true;
      const res = await courseCenterApi.getgoodsTableList(params);
      this.tableLoading = false;
      if (res.status === 200) {
        this.hasGetApi = true;
        this.page.total = Number(res.message.total);
        this.goodsList = res.message.list.map((item) => {
          item.classroomTime = dealTimeList(item);
          return item;
        });
        if (params.schoolId === "" && this.page.total === 0) {
          this.showNullPage = true;
        }
      }
    },
    // 编辑
    handleUpdate(row) {
      const { href } = this.$router.resolve({
        path: "/courseCenter/commodity/commodityTable/addCommodity",
        query: { classroomId: row.classroomId, exsitOrder: row.exsitOrder },
      });
      window.open(href);
    },
    // 发布课程
    handleRelease() {
      // 未上架的课程资源不能去发布课程商品
      if (this.isShelves === 0) {
        this.$Message.error("该课程还未上架，不可添加课程商品");
        return;
      }
      if (this.isShelvesSchoolList.length === 0) {
        this.$Message.error("该课程没有上架学校，请先去上架学校");
        return;
      }
      if (this.selectSchoolId === -1 || this.selectSchoolId === "") {
        this.handleOpenSchool();
        return;
      }
      this.$router.push({
        path: `/courseCenter/commodity/commodityTable/addCommodity`,
        query: {
          schoolId: this.selectSchoolId,
          schoolName: this.schoolName,
          courseId: this.$route.query.courseId,
        },
      });
    },
    handleSchoolSelect(option) {
      this.selectSchoolId = option;
      const obj = this.schoolIdList.find((item) => {
        return item.orgId === option;
      });
      this.schoolName = obj.name;
    },
    // 跳转到订单
    handleToOrder(row) {
      const { href } = this.$router.resolve({
        path: "/orderCenter/order/orderTable",
        query: { courseId: row.classroomId },
      });
      window.open(href);
    },
    // 机构端跳转详情页
    handleToDetail(row) {
      this.$router.push({
        path: "/courseCenter/commodity/commodityTable/commodityDetail",
        query: {
          classroomId: row.classroomId,
          courseId: row.courseId,
        },
      });
    },
    // 删除
    async handleRemove(row, index) {
      this.$Modal.confirm({
        title: "删除商品",
        content: `商品删除后家长无法查看和继续报名，<b>确认删除商品吗？</b>`,
        onOk: () => {
          // this.branchTableData.splice(index);
          this.handleDlect(row);
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        },
      });
    },
    // 删除接口
    async handleDlect(row) {
      const params = {
        classroomId: row.classroomId,
      };
      const res = await courseCenterApi.deleteCourseClass(params);
      if (res.status === 200) {
        this.$Message.info("删除成功");
        this.getgoodsTableListFun();
      }
    },
    editSuccess() {
      this.getgoodsTableListFun();
    },
    handleSet() {
      if (this.classroomIds.length > 0) {
        this.$nextTick(() => {
          this.$refs.batchSettingModal.showModal = true;
        });
      } else {
        this.$Message.error("请至少选择一个！");
      }
    },
    // 设置表格 表头
    handleColumn() {
      this.isShowChooseColumns = true;
    },
    onChooseColumnsOk(columns) {
      this.isShowChooseColumns = false;

      this.columns = columns;
    },
    // 选择学校弹窗打开
    handleOpenSchool(id) {
      this.openModal("chooseSchool", id);
    },
    // 打开弹窗
    openModal(name, id) {
      this.$refs[name].open(id);
    },
    // 关闭弹窗
    closeModal(name) {
      this.$refs[name].close();
    },
    // 获取选择的学校数据
    getSelectSchoolRow(row) {
      this.selectSchoolId = row.orgId;
      this.schoolName = row.orgName;
      this.handleRelease();
    },
  },
};
</script>
<style lang="scss" scoped>
.goods-box {
  background: #fff;
  padding: 16px;
}
.table-operator {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  .school-left {
    display: flex;
    align-items: center;
  }
  .sch-form-item {
    width: 200px;
    margin-left: 16px;
  }
  // .icon-right{
  //   margin-left: auto;
  // }
}
.list-null {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .null-span {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    line-height: 22px;
    margin-top: 4px;
    margin-bottom: 12px;
  }
}
</style>
